import { render } from "./achievement.vue?vue&type=template&id=245d12fa&scoped=true"
import script from "./achievement.vue?vue&type=script&lang=js"
export * from "./achievement.vue?vue&type=script&lang=js"

import "./achievement.vue?vue&type=style&index=0&id=245d12fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245d12fa"]])

export default __exports__